export default __webpack_public_path__ + "static/media/ELEMENTOS DO BG.a3c6a571.png";